import React, { ReactNode } from 'react';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';
import { BreadcrumbProps, Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { styles } from './GenericPage.css';
import { useGenericPageProps } from '../../hooks/content/useGenericPageProps';
import { Disclaimer } from '@jbhi-fi/components/src/Disclaimer';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { MultiColumnBlock, MultiColumnBlockProps } from '@jbhi-fi/components/src/MultiColumnBlock/MultiColumnBlock';

export type GenericPageProps = {
  breadcrumbs: BreadcrumbProps;
  heading: string;
  subheading?: string;
  heroBackgroundColor?: string;
  heroLogo?: ReactNode;
  hasHeroSection?: boolean;
  content: ReactNode;
  htmlContent?: string;
  preFooterSectionProps?: MultiColumnBlockProps;
};

export const GenericPage = () => {
  const { data: genericPage, error } = useGenericPageProps();
  const {
    breadcrumbs,
    heading,
    subheading,
    content,
    htmlContent,
    heroBackgroundColor,
    heroLogo,
    hasHeroSection,
    preFooterSectionProps,
  } = genericPage as GenericPageProps;
  const isDesktop = useBreakpoint('md', 'up');

  if (error) return <>{error}</>;

  return (
    <>
      <div style={{ backgroundColor: hasHeroSection ? heroBackgroundColor : undefined }}>
        {isDesktop || !hasHeroSection ? <Breadcrumbs className={styles.breadcrumbs} {...breadcrumbs} /> : null}
        <ContentBlock
          paddingTop={{ mobile: hasHeroSection ? 7.5 : 5, tablet: 10 }}
          paddingX={{ xs: 4, md: 0 }}
          paddingBottom={hasHeroSection && heroLogo ? { mobile: 7.5, tablet: 10 } : {}}
        >
          {hasHeroSection && heroLogo ? (
            <div className={styles.logoContainer}>{heroLogo}</div>
          ) : (
            <>
              <h1 className={styles.heading}>{heading}</h1>
            </>
          )}
          {subheading ? <p className={styles.subheading}>{subheading}</p> : null}
        </ContentBlock>
      </div>
      <ContentBlock paddingLeft={0} paddingRight={0} paddingTop={0}>
        {content}
      </ContentBlock>
      {htmlContent ? (
        <div className={styles.htmlContent} dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
      ) : null}
      {preFooterSectionProps ? (
        <div style={{ backgroundColor: preFooterSectionProps.theme?.background }}>
          <ContentBlock paddingTop={{ xs: 10, md: 15 }} paddingBottom={{ xs: 10, md: 15 }}>
            <MultiColumnBlock {...preFooterSectionProps} />
          </ContentBlock>
        </div>
      ) : (
        <ContentBlock paddingTop={0} paddingLeft={0} paddingRight={0} paddingBottom={{ mobile: 10, tablet: 20 }}>
          <ContentBlock paddingTop={15} paddingBottom={0} paddingX={{ xs: 4, md: 0 }}>
            <Disclaimer disclaimers={window.Jbhifi.disclaimers} />
          </ContentBlock>
        </ContentBlock>
      )}
    </>
  );
};
